import AppSubMenu from "./AppSubMenu";
import {MenuItems} from "./MenuItems";

const AppMenu = () => {
    // const model: MenuModel[] = [
    //     {
    //         label: "Dashboards",
    //         icon: "pi pi-home",
    //         items: [
    //             {label: "Home", icon: "pi pi-fw pi-home", to: routes.home,},
    //             {label: "Reporting", icon: "pi pi-fw pi-chart-bar", to: routes.reports,},
    //         ],
    //     },
    // ];

    // return <AppSubMenu model={model} />;
    return <AppSubMenu model={MenuItems}/>;
};

export default AppMenu;
